/*
 *
 * MeasurementCreate constants
 *
 */

export const GET_DIVISIONS_WATCHER =
  "app/MeasurementCreate/GET_DIVISIONS_WATCHER"
export const GET_DIVISIONS_SUCCESS =
  "app/MeasurementCreate/GET_DIVISIONS_SUCCESS"
export const GET_DIVISIONS_FAILED = "app/MeasurementCreate/GET_DIVISIONS_FAILED"

export const GET_DESCENDANTS_WATCHER =
  "app/MeasurementCreate/GET_DESCENDANTS_WATCHER"
export const GET_DESCENDANTS_SUCCESS =
  "app/MeasurementCreate/GET_DESCENDANTS_SUCCESS"
export const GET_DESCENDANTS_FAILED =
  "app/MeasurementCreate/GET_DESCENDANTS_FAILED"

export const EDIT_MEASUREMENT_NAME_WATCHER =
  "app/MeasurementCreate/EDIT_MEASUREMENT_NAME_WATCHER"
export const EDIT_MEASUREMENT_NAME_SUCCESS =
  "app/MeasurementCreate/EDIT_MEASUREMENT_NAME_SUCCESS"
export const EDIT_MEASUREMENT_NAME_FAILED =
  "app/MeasurementCreate/EDIT_MEASUREMENT_NAME_FAILED"

export const POST_LOGO_EMAIL_WATCHER =
  "app/MeasurementCreate/POST_LOGO_EMAIL_WATCHER"
export const POST_LOGO_EMAIL_SUCCESS =
  "app/MeasurementCreate/POST_LOGO_EMAIL_SUCCESS"
export const POST_LOGO_EMAIL_FAILED =
  "app/MeasurementCreate/POST_LOGO_EMAIL_FAILED"

export const POST_IMAGE_EMAIL_WATCHER =
  "app/MeasurementCreate/POST_IMAGE_EMAIL_WATCHER"
export const POST_IMAGE_EMAIL_SUCCESS =
  "app/MeasurementCreate/POST_IMAGE_EMAIL_SUCCESS"
export const POST_IMAGE_EMAIL_FAILED =
  "app/MeasurementCreate/POST_IMAGE_EMAIL_FAILED"

export const GET_MEASURE_WATCHER = "app/MeasurementCreate/GET_MEASURE_WATCHER"
export const GET_MEASURE_SUCCESS = "app/MeasurementCreate/GET_MEASURE_SUCCESS"
export const GET_MEASURE_FAILED = "app/MeasurementCreate/GET_MEASURE_FAILED"

export const UPDATE_MEASURE_WATCHER =
  "app/MeasurementCreate/UPDATE_MEASURE_WATCHER"
export const UPDATE_MEASURE_SUCCESS =
  "app/MeasurementCreate/UPDATE_MEASURE_SUCCESS"
export const UPDATE_MEASURE_FAILED =
  "app/MeasurementCreate/UPDATE_MEASURE_FAILED"

export const GET_SEGMENTS_WATCHER = "app/MeasurementCreate/GET_SEGMENTS_WATCHER"
export const GET_SEGMENTS_SUCCESS = "app/MeasurementCreate/GET_SEGMENTS_SUCCESS"
export const GET_SEGMENTS_FAILED = "app/MeasurementCreate/GET_SEGMENTS_FAILED"

export const GET_SURVEY_TYPES_WATCHER =
  "app/MeasurementCreate/GET_SURVEY_TYPES_WATCHER"
export const GET_SURVEY_TYPES_SUCCESS =
  "app/MeasurementCreate/GET_SURVEY_TYPES_SUCCESS"
export const GET_SURVEY_TYPES_FAILED =
  "app/MeasurementCreate/GET_SURVEY_TYPES_FAILED"

export const GET_SCOPE_TYPES_WATCHER =
  "app/MeasurementCreate/GET_SCOPE_TYPES_WATCHER"
export const GET_SCOPE_TYPES_SUCCESS =
  "app/MeasurementCreate/GET_SCOPE_TYPES_SUCCESS"
export const GET_SCOPE_TYPES_FAILED =
  "app/MeasurementCreate/GET_SCOPE_TYPES_FAILED"

export const GET_ORGANIZATION_SURVEYS_WATCHER =
  "app/MeasurementCreate/GET_ORGANIZATION_SURVEYS_WATCHER"
export const GET_ORGANIZATION_SURVEYS_SUCCESS =
  "app/MeasurementCreate/GET_ORGANIZATION_SURVEYS_SUCCESS"
export const GET_ORGANIZATION_SURVEYS_FAILED =
  "app/MeasurementCreate/GET_ORGANIZATION_SURVEYS_FAILED"

export const GET_SEGMENTS_SURVEYS_WATCHER =
  "app/MeasurementCreate/GET_SEGMENTS_SURVEYS_WATCHER"
export const GET_SEGMENTS_SURVEYS_SUCCESS =
  "app/MeasurementCreate/GET_SEGMENTS_SURVEYS_SUCCESS"
export const GET_SEGMENTS_SURVEYS_FAILED =
  "app/MeasurementCreate/GET_SEGMENTS_SURVEYS_FAILED"

export const STEP_ONE_WATCHER = "app/MeasurementCreate/STEP_ONE_WATCHER"
export const STEP_ONE_SUCCESS = "app/MeasurementCreate/STEP_ONE_SUCCESS"
export const STEP_ONE_FAILED = "app/MeasurementCreate/STEP_ONE_FAILED"

export const STEP_MAIL_WATCHER = "app/MeasurementCreate/STEP_MAIL_WATCHER"
export const STEP_MAIL_SUCCESS = "app/MeasurementCreate/STEP_MAIL_SUCCESS"
export const STEP_MAIL_FAILED = "app/MeasurementCreate/STEP_MAIL_FAILED"

export const STEP_TWO_WATCHER = "app/MeasurementCreate/STEP_TWO_WATCHER"
export const STEP_TWO_SUCCESS = "app/MeasurementCreate/STEP_TWO_SUCCESS"
export const STEP_TWO_FAILED = "app/MeasurementCreate/STEP_TWO_FAILED"

export const STEP_RECIPIENTS_WATCHER =
  "app/MeasurementCreate/STEP_RECIPIENTS_WATCHER"
export const STEP_RECIPIENTS_SUCCESS =
  "app/MeasurementCreate/STEP_RECIPIENTS_SUCCESS"
export const STEP_RECIPIENTS_FAILED =
  "app/MeasurementCreate/STEP_RECIPIENTS_FAILED"

export const STEP_DATACHECK_WATCHER =
  "app/MeasurementCreate/STEP_DATACHECK_WATCHER"
export const STEP_DATACHECK_SUCCESS =
  "app/MeasurementCreate/STEP_DATACHECK_SUCCESS"
export const STEP_DATACHECK_FAILED =
  "app/MeasurementCreate/STEP_DATACHECK_FAILED"

export const STEP_PREVIEW_WATCHER = "app/MeasurementCreate/STEP_PREVIEW_WATCHER"
export const STEP_PREVIEW_SUCCESS = "app/MeasurementCreate/STEP_PREVIEW_SUCCESS"
export const STEP_PREVIEW_FAILED = "app/MeasurementCreate/STEP_PREVIEW_FAILED"

export const STEP_SCHEDULE_WATCHER =
  "app/MeasurementCreate/STEP_SCHEDULE_WATCHER"
export const STEP_SCHEDULE_SUCCESS =
  "app/MeasurementCreate/STEP_SCHEDULE_SUCCESS"
export const STEP_SCHEDULE_FAILED = "app/MeasurementCreate/STEP_SCHEDULE_FAILED"

export const STEP_COMPLETE_WATCHER =
  "app/MeasurementCreate/STEP_COMPLETE_WATCHER"
export const STEP_COMPLETE_SUCCESS =
  "app/MeasurementCreate/STEP_COMPLETE_SUCCESS"
export const STEP_COMPLETE_FAILED = "app/MeasurementCreate/STEP_COMPLETE_FAILED"

export const FORCE_SAVE_WATCHER = "app/MeasurementCreate/FORCE_SAVE_WATCHER"
export const FORCE_SAVE_SUCCESS = "app/MeasurementCreate/FORCE_SAVE_SUCCESS"
export const FORCE_SAVE_FAILED = "app/MeasurementCreate/FORCE_SAVE_FAILED"

export const GET_EMPLOYEES_BY_SEGMENTS_WATCHER =
  "app/MeasurementCreate/GET_EMPLOYEES_BY_SEGMENTS_WATCHER"
export const GET_EMPLOYEES_BY_SEGMENTS_SUCCESS =
  "app/MeasurementCreate/GET_EMPLOYEES_BY_SEGMENTS_SUCCESS"
export const GET_EMPLOYEES_BY_SEGMENTS_FAILED =
  "app/MeasurementCreate/GET_EMPLOYEES_BY_SEGMENTS_FAILED"

export const STEP_THIRD_WATCHER = "app/MeasurementCreate/STEP_THIRD_WATCHER"
export const STEP_THIRD_SUCCESS = "app/MeasurementCreate/STEP_THIRD_SUCCESS"
export const STEP_THIRD_FAILED = "app/MeasurementCreate/STEP_THIRD_FAILED"

export const STEP_FOURTH_WATCHER = "app/MeasurementCreate/STEP_FOURTH_WATCHER"
export const STEP_FOURTH_SUCCESS = "app/MeasurementCreate/STEP_FOURTH_SUCCESS"
export const STEP_FOURTH_FAILED = "app/MeasurementCreate/STEP_FOURTH_FAILED"

export const STEP_FINISH_WATCHER = "app/MeasurementCreate/STEP_FINISH_WATCHER"
export const STEP_FINISH_SUCCESS = "app/MeasurementCreate/STEP_FINISH_SUCCESS"
export const STEP_FINISH_FAILED = "app/MeasurementCreate/STEP_FINISH_FAILED"

export const GET_LEADERS_WATCHER = "app/MeasurementCreate/GET_LEADERS_WATCHER"
export const GET_LEADERS_SUCCESS = "app/MeasurementCreate/GET_LEADERS_SUCCESS"
export const GET_LEADERS_FAILED = "app/MeasurementCreate/GET_LEADERS_FAILED"

export const GET_SURVEYS_TYPE_WATCHER =
  "app/MeasurementDetails/GET_SURVEYS_TYPE_WATCHER"
export const GET_SURVEYS_TYPE_SUCCESS =
  "app/MeasurementDetails/GET_SURVEYS_TYPE_SUCCESS"
export const GET_SURVEYS_TYPE_FAILED =
  "app/MeasurementDetails/GET_SURVEYS_TYPE_FAILED"
